<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { onMounted, ref } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import AccountCell from '@/onenetwork/components/datatable/AccountCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { CONSULTATION_API } from '@/modules/contract/constants/contract.api.uri.const'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import {
  CONSULTATION_STATUS,
} from './../constants/contract.constant';

interface Props {
  id: string | number;
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
const dataSource = ref<any>({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {
  if (page !== page.value) {
    page.value = page
    requestFetchData()
  }
}

const handleChangePageSize = (size: number) => {
  if (size !== pageSize.value) {
    pageSize.value = size
    page.value = 1 // Reset to first page when changing page size
    requestFetchData()
  }
}

const requestFetchData = async () => {
  try{
    const res = await APIClient.get(CONSULTATION_API, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        listing_id: props.id,
      }
    });

    const { data } = res.data;
    if (res.data.code === 200) {
      dataSource.value = {
        list: (data.data || []).map((item: any) => ({
          id: item.id,
          info: [{
            type: CONSULTATION_STATUS.find((option) => option.id === item.admin_status)?.color,
            label: CONSULTATION_STATUS.find((option) => option.id === item.admin_status)?.label
          }],
          code: `#${item.id}`,
          customer: {
            ...item.customer,
            name: item.customer.name || item.customer.full_name,
            phone: item.customer.phone || item.customer.phone_number || '',
          },
          content: item.content,
          deliveries_count: item.deliveries_count,
          borker: item.current_delivery ? {
            ...item.current_delivery.broker,
            name: item.current_delivery.broker.name || item.current_delivery.broker.full_name,
            phone: item.current_delivery.broker.phone || item.current_delivery.broker.phone_number || '',
          } : '',
          created_at: item.created_at,
          updated_at: item.updated_at,
        })),
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }
  } catch (e) {

  }
}

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        info: { label: 'Trạng thái', component: TagCell, visible: true, sort: false, config: {} },
        code: { label: 'Mã yêu cầu', component: TextCell, visible: true, sort: false, config: {} },
        customer: { label: 'Khách hàng', component: AccountCell, visible: true, class: '', sort: false, config: {} },
        content: { label: 'Nội dung yêu cầu', component: TextCell, visible: true, sort: false, class: '', config: {} },
        deliveries_count: { label: 'Đã phân phối', component: TextCell, visible: true, sort: false, class: '', config: {} },
        borker: { label: 'Môi giới chăm sóc', component: AccountCell, visible: true, sort: false, class: '', config: {} },
        created_at: { label: 'Ngày đăng ký YC', component: DateTimeCell, visible: true, sort: false, class: '', config: {} },
        updated_at: { label: 'Ngày xác nhận YC', component: DateTimeCell, visible: true, sort: false, class: '', config: {} },
      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
